var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.2002C12.3686 16.2002 16 12.5767 16 8.2002C16 3.83157 12.3608 0.200195 7.99216 0.200195C3.61569 0.200195 0 3.83157 0 8.2002C0 12.5767 3.62353 16.2002 8 16.2002ZM8 14.8669C4.29804 14.8669 1.34118 11.9022 1.34118 8.2002C1.34118 4.50608 4.2902 1.53353 7.99216 1.53353C11.6863 1.53353 14.6588 4.50608 14.6667 8.2002C14.6745 11.9022 11.6941 14.8669 8 14.8669ZM7.97647 11.9257C7.56078 11.9257 7.33333 11.6198 7.33333 11.1806V8.85902H4.88627C4.44706 8.85902 4.13333 8.63157 4.13333 8.21588C4.13333 7.79235 4.42353 7.54922 4.88627 7.54922H7.33333V5.08647C7.33333 4.63941 7.56078 4.34137 7.97647 4.34137C8.4 4.34137 8.65098 4.62372 8.65098 5.08647V7.54922H11.1059C11.5608 7.54922 11.851 7.79235 11.851 8.21588C11.851 8.63157 11.5451 8.85902 11.1059 8.85902H8.65098V11.1806C8.65098 11.6355 8.4 11.9257 7.97647 11.9257Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlusCircle.9d2d17ef482353c78b3a3a67324b5b56.svg";